<template>
  <section class="l-section wpb_row height_small width_full mpc-row"
           style="margin-top: -50px !important;"
  >
    <div class="l-section-h i-cf">
      <div class="g-cols type_default valign_top">
        <div class="vc_col-sm-12 wpb_column vc_column_container mpc-column"
             data-column-id="mpc_column-45e6f459d779b5"
        >
          <div class="vc_column-inner">
            <div class="wpb_wrapper">
              <div class="vc_empty_space"
                   style="height: 90px"
              ><span class="vc_empty_space_inner"></span></div>
              <div class="wpb_text_column ">
                <div class="wpb_wrapper">
                  <p style="text-align: center;">{{$t("Ви бажаєте дізнаватися про акції та пропозиції від закладу?")}}</p>
                </div>
              </div>

              <button type="button"
                      class="base-btn"
                      @click.prevent="onOpenSubscribe"
              >{{$t('Приєднатися до нас')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'JoinUs',
    methods: {
      onOpenSubscribe() {
        this.$vModal.open('subscribe')
      }
    }
  }
</script>

<style>

</style>
